<template>
<md-whiteframe class="project-box">
    <md-card class="project-box-content">
        <md-card-header>
            <h1 class="md-title">Pending Project Invites</h1>
        </md-card-header>
        <md-card-content>
            <md-layout md-flex="25" class="project-box-container md-row" v-for="project in projects" :key="project.id">
                <h1 class="md-subheader pending-subheader">{{project.title}}</h1>
                <md-button class="md-mini md-fab pending-action-button" @click="accept(project)">
                    <md-icon>person_add</md-icon>
                    <md-tooltip>Join Project</md-tooltip>
                </md-button>
                <md-button class="md-mini md-fab pending-action-button" @click="decline(project)">
                    <md-icon>delete</md-icon>
                    <md-tooltip>Cancel Invite</md-tooltip>
                </md-button>
            </md-layout>
        </md-card-content>
    </md-card>
</md-whiteframe>
</template>

<script>
/**
 * Module for managing a grid of project boxes
 */
import DashboardProjectBox from '@/components/dashboard/project-box';

const PendingProjects = {
    name: 'PendingProjects',
    props: ['projects', 'user'],
    data: function() {
        return {};
    },
    methods: {
        accept(project) {
            const pendingCollaborators = Object.values(project.pendingCollaborators);
            const pcIndex = pendingCollaborators.findIndex((pc) => {
                return pc.email === this.user.email;
            });
            const pendingCollab = pendingCollaborators[pcIndex];

            // const projectRef = firebase.database().ref(`/projects/${project.id}`);
            // const collabsRef = projectRef.child('collaborators');
            // const pendingCollabsRef = projectRef.child('pendingCollaborators');

            // const collab = {uid: this.user.uid, layers: {}, role: pendingCollab.role};

            // Object.keys(project.layers).forEach((layer) => {
            //     collab.layers[layer] = false;
            // });
            
            // collabsRef.child(`${collab.uid}`).set(collab).then(() => {
            //     pendingCollabsRef.child(pendingCollab.id).remove();
            // });
            this.$store.dispatch('addCollaborator', {
                project: project,
                uid: this.user.uid,
                pendingCollaborator: pendingCollab
            });
        },
        decline(project) {
            const pendingCollaborators = Object.values(project.pendingCollaborators);
            const pcIndex = pendingCollaborators.findIndex((pc) => {
                return pc.email === this.user.email;
            });
            const pendingCollab = pendingCollaborators[pcIndex];

            this.$store.dispatch('removePendingCollaborator', {
                project: project,
                pendingCollaboratorID: pendingCollab.id
            });
        }
    },
    components: {
        'dashboard-project-box': DashboardProjectBox
    }
};
export default PendingProjects;

</script>

<style lang="scss">
.project-box {
    position: relative;
    width: 100%;
    padding-top: 100%;
    .project-box-content {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        text-align: center;
        .md-card-actions {
            position: absolute;
            bottom: 0;
            text-align: right;
            width: 100%;
        }
        overflow: hidden;
        .pending-action-button {
            background: #5ecfdf !important;
            &:hover {
                background: #5ecfdf !important;
            }
        }
    }
}
.project-box-container {
    margin-top: 8px;
    flex-wrap: nowrap;
}

.md-subheader {
    flex: auto;
}

.md-theme-show-mode {
    .pending-subheader {
        color: rgba(255, 255, 255, 0.87);
    }
}
</style>


// WEBPACK FOOTER //
// pending-projects.vue?338b88f8